import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

/**
 * @param {{
 *   open: boolean,
 *   message: string,
 *   onClose: () => void,
 *   severity?: 'info' | 'success' | 'warning' | 'error',
 *   autoHideDuration?: number,
 *   anchorOrigin?: { vertical: 'top' | 'bottom', horizontal: 'left' | 'center' | 'right' },
 * }} props
 */
export default function AppSnackbar({
  open,
  message,
  onClose,
  severity = 'info',
  autoHideDuration = 8000,
  anchorOrigin = { vertical: 'bottom', horizontal: 'center' },
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert severity={severity} onClose={onClose} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
